module.exports = __webpack_public_path__ + "static/media/IMG_20181113_004408.64b928a5.jpeg";